import { render } from "./RecipientDrillDown.vue?vue&type=template&id=50d72775&scoped=true"
import script from "./RecipientDrillDown.vue?vue&type=script&lang=js"
export * from "./RecipientDrillDown.vue?vue&type=script&lang=js"

import "./RecipientDrillDown.vue?vue&type=style&index=0&id=50d72775&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d72775"]])

export default __exports__